import { createTimeline } from '../../vendor/anime.esm.js';
import { DURATION, EASE, resolveDuration, SUPPORTS_CLIP } from '../motion-tokens.js';

export const mapsV1 = (el) => {
    // v1: centrado — PRIMARIO: mapa se revela con clipPath circular desde el centro.
    const map  = el.querySelector('.map-container, iframe, [class*="map"]');
    const info = el.querySelector('.map-info, .location-info, address, .map-header');
    const tl = createTimeline({ defaults: { ease: EASE.refined }, });

    // Estado inicial forzado (previene FOVC)
    if (map) { map.style.opacity = '0'; }
    if (info) { info.style.opacity = '0'; info.style.transform = 'translateY(15px)'; info.style.filter = 'blur(3px)'; }

    if (info) tl.add(info, {
        opacity:    [0, 1],
        translateY: [15, 0],
        filter:     ['blur(3px)', 'blur(0px)'],
        duration:   resolveDuration(DURATION.normal),
    });

    // Primario: mapa emerge en círculo expansivo
    if (map) {
        if (SUPPORTS_CLIP) {
            tl.add(map, {
                clipPath: ['circle(0% at 50% 50%)', 'circle(75% at 50% 50%)'],
                opacity:  [0, 1],
                duration: resolveDuration(DURATION.slow),
                ease:     EASE.snappy,
            }, info ? '-=300' : 0);
        } else {
            tl.add(map, {
                opacity:    [0, 1],
                scale:      [0.9, 1],
                duration:   resolveDuration(DURATION.slow),
            }, info ? '-=300' : 0);
        }
    }

    return tl;
};

export const mapsV2 = (el) => {
    // v2: split 60/40 — PRIMARIO: mapa desde la derecha con clipPath. SECUNDARIO: info desde izq.
    const map  = el.querySelector('.map-container, iframe, [class*="map"]');
    const info = el.querySelector('.map-info, .location-info, address');
    const tl = createTimeline({ defaults: { ease: EASE.refined }, });

    // Estado inicial forzado (previene FOVC)
    if (map) { map.style.opacity = '0'; }
    if (info) { info.style.opacity = '0'; info.style.transform = 'translateX(-40px)'; info.style.filter = 'blur(3px)'; }

    // Secundario: info entra desde la izquierda
    if (info) {
        tl.add(info, {
            opacity:    [0, 1],
            translateX: [-40, 0],
            filter:     ['blur(3px)', 'blur(0px)'],
            duration:   resolveDuration(DURATION.normal),
        }, 0);
    }

    // Primario: mapa se revela desde la derecha con cortina
    if (map) {
        if (SUPPORTS_CLIP) {
            tl.add(map, {
                clipPath: ['inset(0 0% 0 100%)', 'inset(0 0% 0 0%)'],
                opacity:  [0, 1],
                duration: resolveDuration(DURATION.slow),
                ease:     EASE.snappy,
            }, 80);
        } else {
            tl.add(map, {
                opacity:    [0, 1],
                translateX: [60, 0],
                duration:   resolveDuration(DURATION.slow),
            }, 80);
        }
    }

    return tl;
};
